function n(n,r){return!0}export{n as hasPermission};
